import React, { Component } from 'react';
import {bounce} from 'engine/BouncingEngine.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {PUBLIC} from 'constants/save-sequence-options.js';

class LinkCreator extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sequenceHash: undefined,
            creatingLink: false,
        };
    }

    getLink() {
        if (window.explore) {
            return "https://zequencer.io/explore/" + this.state.sequenceHash;
        } else {
            return "https://zequencer.io/create/" + this.state.sequenceHash;
        }
    }

    copyLink() {
        let copyText = this.linkInput;
        copyText.select();
        copyText.setSelectionRange(0, 99999); /*For mobile devices*/
        
        /* Copy the text inside the text field */
        document.execCommand("copy");
        
        this.setState({copied: true});
        setTimeout(() => this.setState({copied: false}), 1000);
    }

    async createLink() {
        this.setState({creatingLink: true});
        // post w/o saving to ethereum first
        let hash = await this.props.sequencerEngine.save(undefined, PUBLIC, false);
        this.setState({
            sequenceHash: hash,
            creatingLink: false,
        });
    }

    exportToWAV() {
        bounce(this.props.sequencerEngine);
    }

    render() {
        return (
            <div className="link-creator">
              <ConditionedComponent condition={this.state.sequenceHash === undefined}>
                <div
                  onClick={() => this.createLink()}
                  className="link-button">
                  Create Public Link
                </div>
              </ConditionedComponent>
              <ConditionedComponent condition={this.state.sequenceHash !== undefined}>
                <div>
                  Link: <input type="text" value={this.getLink()} id="linkInput"
                               ref={(input) => { this.linkInput= input; }}/>
                </div>
                <div
                  onClick={() => this.copyLink()}
                  className="small-button pink-button">Copy Link</div>
                <div className="clear-fix"/>
                <ConditionedComponent condition={this.state.copied}>
                  <div className="copied-info">Copied to clipboard!</div>
                </ConditionedComponent>
              </ConditionedComponent>
              <div
                onClick={() => this.props.onClickExport()}
                className="link-button">
                Export to WAV 
              </div>
            </div>
        );
    }
}

export default LinkCreator;
